import { render } from "./makeTableModel.vue?vue&type=template&id=fa48afee"
import script from "./makeTableModel.vue?vue&type=script&lang=js"
export * from "./makeTableModel.vue?vue&type=script&lang=js"

import "./makeTableModel.vue?vue&type=style&index=0&id=fa48afee&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__